const getField = (placeholderElementId, isMobile) =>
  isMobile ? { inputType: 'tel', placeholderElementId } : placeholderElementId;

export const getFields = ({ isMobile = false, showCVV = true } = {}) => ({
  cardNumber: getField('card', isMobile),
  ...(showCVV ? { cvv: getField('cvv', isMobile) } : undefined),
});
